import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QAFormHelper } from '../../../services/qa-form-helper';
import {
  FormControlsDefinition,
  FormControlsDefinitionChildKey,
  PutAnswer,
} from '@domgen/dgx-components';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'claims-question-form-accessory',
  templateUrl: './question-accessory.component.html',
  styleUrls: ['./question-accessory.component.scss'],
  providers: [QAFormHelper],
})
export class QuestionFormAccessoryInputComponent {
  @Input() group;
  @Input() form;
  @Input() questions;
  @Input() control: string = 'accessory';

  showValidation = false;
  selectedValue = null;

  @Output() answer: EventEmitter<PutAnswer> = new EventEmitter();

  nestedForm: UntypedFormGroup;
  nestedQuestions: FormControlsDefinition[];

  constructor(private qaHelper: QAFormHelper) {}

  createForm(nestedQuestion, defaultFormValues = {}) {
    this.nestedQuestions = this.qaHelper.generateQuestionFormData([
      {
        question: nestedQuestion,
        answer: null,
      },
    ]);

    this.nestedForm = this.qaHelper.createForm(
      this.nestedQuestions,
      defaultFormValues
    );
  }

  onSelectionChanged(value: any) {
    this.selectedValue = value;
  }

  onSumbit(group: any) {
    this.showValidation = false;
    if (!this.selectedValue) {
      this.showValidation = true;
      return;
    }
    this.answer.emit({
      AnswerValue: group?.radios?.radioGroup?.find(
        (r) => r.value === this.selectedValue.value
      )?.hiddenAccessibilityText,
      AnswerID: this.selectedValue.value,
      QuestionID: group?.radios?.control as string,
    });
  }
}
